const snackbarPlugin = {
  install: (Vue, {
    store
  }) => {
    if (!store) {
      throw new Error('Please provide vuex store.');
    }

    Vue.prototype.$snackbar = {
      showMessage: function ({
                               icon = '',
                               content = '',
                               snackbarColor = '',
                               snackbarBtnColor = ''
                             }) {
        store.commit(
          'snackbar/showMessage', {
            icon,
            content,
            snackbarColor,
            snackbarBtnColor
          }, {
            root: true
          }
        );
      }
    };
  },
};
export default snackbarPlugin;
